import { z } from 'zod';
import { JOB_STATUS, ASPECT_RATIO, GENERATION_STAGE, CONTENT_TYPE } from '../types/common.js';
import { createDramaTreatmentInputSchema } from './drama.js';

/**
 * GenerationJob — field list untuk UI polling.
 */
export const generationJobSchema = z.object({
  id: z.string().min(1),
  productId: z.string().min(1),
  storyboardId: z.string().min(1).nullable().optional(),
  currentStep: z.enum(JOB_STATUS),
  progress: z.number().int().min(0).max(100),
  startedAt: z.string(),
  updatedAt: z.string().nullable().optional(),
  errorCode: z.string().nullable().optional(),
  errorMessage: z.string().nullable().optional(),
  provider: z.string().nullable().optional(),
  model: z.string().nullable().optional(),
  retryCount: z.number().int().nonnegative(),
  idempotencyKey: z.string().nullable().optional(),
  queueMessageId: z.string().nullable().optional(),
  mockResult: z.record(z.unknown()).nullable().optional(),
  contentType: z.enum(CONTENT_TYPE).default('ad'),
});
export type GenerationJob = z.infer<typeof generationJobSchema>;

export const createGenerationJobInputSchema = z.object({
  productId: z.string().min(1),
  storyboardId: z.string().min(1).optional(),
  presetKey: z.string().min(1).optional(),
  promptPackageId: z.string().min(1).optional(),
  idempotencyKey: z.string().min(1).optional(),
  aspectRatio: z.enum(ASPECT_RATIO).optional(),
  durationSeconds: z.number().int().positive().max(180).optional(),
  // Pipeline drama
  contentType: z.enum(CONTENT_TYPE).default('ad'),
  dramaTreatment: createDramaTreatmentInputSchema.optional(),
});
export type CreateGenerationJobInput = z.infer<typeof createGenerationJobInputSchema>;

/**
 * Body pesan Cloudflare Queue — satu pesan per transisi stage.
 * Pipeline baru: PLANNING → CONCEPT_GENERATION → STORYBOARD_DRAFT
 *               → HUMAN_REVIEW → PROMPT_EXPORT → COMPLETED
 */
export const jobQueueMessageSchema = z.object({
  jobId: z.string().min(1),
  stage: z.enum(GENERATION_STAGE),
  context: z.record(z.unknown()).optional(),
});
export type JobQueueMessage = z.infer<typeof jobQueueMessageSchema>;
